<template>
  <div class="wrapper">
    <h3>檔案下載專區</h3>
    <ul class="download_list">
      <li v-for="file in downloadList.items" :key="file.fileId">
        <a
          :title="file.fileName"
          @click="downloadFile(file)"
          href="javascript:void(0)"
          >{{ file.fileName }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { getDownloadItems, getDownloadFileAPI } from "@/api/api.js";

export default defineComponent({
  setup() {
    const downloadList = reactive({
      items: [],
    });

    const fetchDownloadList = async () => {
      const { data } = await getDownloadItems();
      downloadList.items = data.uploadFiles ?? [];
    };
    fetchDownloadList();

    const downloadFile = async ({ fileId, fileExtension, fileName }) => {
      const res = await getDownloadFileAPI(fileId);

      let type = "";
      switch (fileExtension) {
        case "xlsx":
          type = "application/vnd.ms-excel";
          break;
        case "zip":
        case "pdf":
          type = `application/${fileExtension}`;
          break;
        default:
          type = `image/${fileExtension}`;
          break;
      }
      const blob = new Blob([res.data], {
        type,
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(link.href);
    };

    return { downloadList, downloadFile };
  },
});
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: left;
  margin: 20px 0 100px;
  h5 {
    font-size: 1.25em;
    padding: 8px;
    background: #eee;
    margin-bottom: 5px;
  }
  a {
    font-size: 1.125em;
    padding: 8px;
    color: $main_color;

    &:hover {
      cursor: pointer;
    }
  }

  li {
    border-bottom: 1px solid #eee;
  }
}
</style>
